import React from 'react';
import { CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
export const BookingSuccessPage = () => {
  return <div className="bg-white w-full min-h-screen" data-id="element-637">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-32" data-id="element-638">
        <div className="text-center" data-id="element-639">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-6" data-id="element-640">
            <CheckCircle className="h-12 w-12 text-green-600" data-id="element-641" />
          </div>

          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-642">
            Request Submitted Successfully!
          </h1>

          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-643">
            Thank you for your booking request. We've received all your details
            and will get back to you shortly to confirm availability.
          </p>

          <div className="bg-primary-50 border border-primary-200 rounded-lg p-6 mb-8 max-w-xl mx-auto" data-id="element-644">
            <h2 className="font-semibold text-gray-900 mb-3" data-id="element-645">
              What happens next?
            </h2>

            <ul className="text-left space-y-2 text-gray-700" data-id="element-646">
              {/* undefined"flex items-start"> */}
              <span className="text-primary-500 mr-2" data-id="element-647">1.</span>
              <span data-id="element-648">
                We'll review your booking request and check availability
              </span>

              {/* </li> */}
              <li className="flex items-start" data-id="element-649">
                <span className="text-primary-500 mr-2" data-id="element-650">2.</span>
                <span data-id="element-651">You'll receive a confirmation email within 24 hours</span>
              </li>
              <li className="flex items-start" data-id="element-652">
                <span className="text-primary-500 mr-2" data-id="element-653">3.</span>
                <span data-id="element-654">
                  We'll finalize all the details and prepare for your event
                </span>
              </li>
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-655">
            <Link to="/" className="inline-flex items-center justify-center px-6 py-3 bg-primary-500 text-white rounded-lg font-medium hover:bg-primary-600 transition-all shadow-md" onClick={() => window.scrollTo(0, 0)} data-id="element-656">
              Return to Home
            </Link>
            <Link to="/contact" className="inline-flex items-center justify-center px-6 py-3 border-2 border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-all" onClick={() => window.scrollTo(0, 0)} data-id="element-657">
              Contact Us
            </Link>
          </div>

          <div className="mt-12 pt-8 border-t border-gray-200" data-id="element-658">
            <p className="text-gray-600 mb-2" data-id="element-659">
              <strong data-id="element-660">Questions?</strong> Feel free to reach out:
            </p>
            <p className="text-gray-700" data-id="element-661">
              <a href="tel:4702430414" className="text-primary-500 hover:text-primary-600 font-medium" data-id="element-662">
                (470) 243-0414
              </a>
              {' or '}
              <a href="mailto:info@toddlertimeatl.com" className="text-primary-500 hover:text-primary-600 font-medium" data-id="element-663">
                info@toddlertimeatl.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>;
};
/* div > */
/* ; */